export const GENERIC_DISPLAY = {
  doNotHavePermissionAsReader: 'Vous ne pouvez pas modifier en tant que lecteur',
}
